module.exports = __webpack_public_path__ + "static/media/40-15.ce87adbe.mp3";